import Vue from 'vue'
import App from './App.vue'
import router from './router'
import http from "./js/request"
import store from "./js/store"
import Swiper from 'swiper/bundle';
// import Swiper styles
import 'swiper/swiper-bundle.css';
import VueWaypoint from 'vue-waypoint'
Vue.use(VueWaypoint)
Vue.use(http)

Vue.prototype.$Swiper = Swiper;
Vue.prototype.$store = store;

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  store.state.currentRoute = to.name;
  next();
})

router.afterEach((to, from) => {
  document.getElementsByTagName('html')[0].scrollTop = 0;
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
